<template>
	<div class="apply-box" v-show="applyLogin" @click.self="closeWin">
		<div class="box">
			<div class="box_title">申请入驻</div>
			<p class="box_label">您如何称呼</p>
			<p class="enter_box" :class="{redBorder:nodataId == 1}"><input v-model="form.username" type="text"  placeholder="你的姓名"/></p>
			<p class="box_label">您的联系方式</p>
			<p class="enter_box"  :class="{redBorder:nodataId == 2}"><input v-model="form.phone" type="text"  placeholder="联系方式"/></p>
			<p class="box_label">您所在学校</p>
			<p class="enter_box" :class="{redBorder:nodataId == 3}"><input  v-model="form.school" type="text"  placeholder="学校名称"/></p>
			<p class="applyIn" @click="postdata">申请入驻</p>
			<p class="our_phone">联系电话：400-840-8168转843</p>
		</div>
		<div class="tosat" v-if="tishi">{{tishiWord}}</div>
	</div>
</template>

<script>
	import { applyIn } from '@/axios';
	export default {
		data(){
			return{
				tishi:false,
				tishiWord:"",
				nodataId:'',
				form:{
					phone:"",
					username:"",
					school:""
				}
			}
		},
		props: {
			applyLogin: {
				type: Boolean,
				default: false
			},
		},
		methods: {
			// 表单提交
			postdata() {
				var that = this;
				if (that.form.username == "") {
					that.tishiWord = "请输入您的姓名";
					that.tishi = true;
					setTimeout(function() {
						that.tishi = false
					}, 1000);
					that.nodataId = 1
				} else if(that.form.phone == ""){
					that.tishiWord = "请输入您的联系方式";
					that.tishi = true;
					setTimeout(function() {
						that.tishi = false
					}, 1000);
					that.nodataId = 2
				}else if(that.form.school == ""){
					that.tishiWord = "请输入您的学校名称";
					that.tishi = true;
					setTimeout(function() {
						that.tishi = false
					}, 1000);
					that.nodataId = 3
				}else{
					if(that.checkPhone(that.form.phone)){
						applyIn.applyIn(that.form).then(res =>{
							if(res.code == 200){
								that.tishiWord = "申请成功";
								that.tishi = true;
								setTimeout(function() {
									that.tishi = false
								}, 1000);
							}else{
								that.tishiWord = res.msg;
								that.tishi = true;
								setTimeout(function() {
									that.tishi = false
								}, 1000);
							}
							that.nodataId = "";
							that.closeWin();
						})
					}else{
						that.tishiWord = "请输入正确的手机号";
						that.tishi = true;
						setTimeout(function() {
							that.tishi = false
						}, 1000);
						that.nodataId = 3
					}
				}
			},
			closeWin(){
				var that = this;
				that.tishiWord = ""
				that.nodataId = ''
				that.$emit('closeWin')
			},
			// 手机号正则
			checkPhone(number){
				var that = this;
				// 手机号正则
				if(number.length != 11){
					that.tishiWord = "请输入正确的手机号";
					that.tishi = true;
					setTimeout(function() {
						that.tishi = false
					}, 1000);
					that.nodataId = 3
				}else{
					if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(number))){
						that.tishiWord = "请输入正确的手机号";
						that.tishi = true;
						setTimeout(function() {
							that.tishi = false
						}, 1000);
						that.nodataId = 3
						return false;
					}else{
						return true;
					}
				}
			},
		},
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.apply-box{
		z-index: 20;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(28, 28, 28, 0.6);
		height: 100%;
		width: 100%;
		.box{
			position: absolute;
			width: 480px;
			height: 579px;
			background: #FFFFFF;
			box-shadow: 0px 5px 15px 0px rgba(30, 33, 41, 0.1);
			border-radius: 28px;
			border: 2px solid #CB272B;
			margin: 0 auto;
			top: 50%; 
			left: 50%;
			transform: translate(-50% ,-50%);
			padding: 50px 50px;
			box-sizing: border-box;
			>p{
				margin-top: 25px;
			}
			&_title{
				font-size: 24px;
				color: #CB272B;
				width: 100%;
				text-align: center;
				font-weight: bold;
			}
			&_label{
				font-size: 16px;
				color: $indexColor2;
				font-weight: bold;
			}
			.enter_box{
				width: 100%;
				box-sizing: border-box;
				height: 40px;
				background: #FFFFFF;
				border-radius: 4px;
				border: 1px solid #DDE2EE;
				padding: 0 10px;
				input{
					font-size: 14px;
					color: #919191;
					border: none;
					height: 100%;
					width: 100%;
					outline: none;
				}
				.input:focus{
					border: 1px solid #bb0000 !important;
				}
			}
			.applyIn{
				cursor: pointer;
				width: 100%;
				height: 40px;
				color: #fff;
				font-weight: bold;
				font-size: 16px;
				line-height: 40px;
				text-align: center;
				background: #CB272B;
				border-radius: 4px;
			}
			.applyIn:hover{
				opacity: 0.8;
			}
			.our_phone{
				text-align: center;
				color: #919191;
				font-size: 12px;
				margin-top: 40px !important;
			}
		}
		.tosat{
			z-index: 10;
			position: absolute;
			top: 50%; 
			left: 50%;
			height: 50px;
			line-height: 50px;
			width: 200px;
			background: rgba(0,0,0,.7);
			text-align: center;
			color: #fff;
			font-size: 16px;
			transition: all 0.3s;
			transform: translate(-50% ,-50%);
		}
	}
	.redBorder{
		border: 1px solid #bb0000 !important;
	}
</style>
